import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'SubFunciones';

export interface SubFuncion {
	idSubFuncion: string;
	subFuncion: string;
	idTipo: number;
}

export class SubFuncionesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarSubFunciones(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarSubFunciones`);
	}

	ListarSubFuncionesByFuncion(idFuncion:number): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarSubFunciones/${idFuncion}`);
	}

	ListarSubFuncionesByAreaFuncion(request:any): AxiosPromise<any[]> {
		return this.cliente.post(request,`/ListarSubFuncionesAreaFuncion`);
	}

	CrearSubFuncion(subFuncion:any): AxiosPromise<any[]> {
		return this.cliente.post(subFuncion,`/CrearSubFuncion`);
	}
	
	EliminarSubFuncion(id: number): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarSubFuncion`);
	}

	ModificarSubFuncion(subFuncion: any): AxiosPromise<any[]> {
		return this.cliente.put(subFuncion.idSubFuncion, subFuncion, `/ModificarSubFuncion`);
	}
}